import React from 'react'
import { Box, CircularProgress, Typography } from '@material-ui/core'

export default function LoadingScreen() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="grey.800"
      color="white"
    >
      <CircularProgress color="inherit" />
      <Box mt={4}>
        <Typography>Loading, Please wait...</Typography>
      </Box>
    </Box>
  )
}
